
<div class="ai-token-modal">
<div class="header">
  <h4>AI Token Tracker</h4>
  <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
</div>


      <div class="ait-desc-main">
      <div class="ait-desc"><div class="ad-left">Subscription Level:</div><div class="ad-right">Premium</div></div>
      <div class="ait-desc"><div class="ad-left">Tokens Available:</div><div class="ad-right">75 / 100 </div></div>
      <div class="ait-desc"><div class="ad-left">Image Generation:</div><div class="ad-right">1 AI Token</div></div>
      <div class="ait-desc"><div class="ad-left">Remaining Tokens:</div><div class="ad-right">25</div></div>
      <div class="ai-token-msg">
        ⚠️You have no tokens left.<br>
- Upgrade your subscription to get more tokens.
      </div>
      <div class="ait-desc"><div class="ad-left">See Subscription Levels:</div>
      <div class="ad-right"><a href="#">Upgrade Plan</a></div>
      </div>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-theme">No thanks</button>
      <button type="button" class="btn btn-dark">Generate<img src="assets/icons/icon-generate.svg" alt=""></button>
  </div>

</div> 
<div class="generate-promt-modal">
  <div class="header">
    <h4>Generate portrait using prompt</h4>
    <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
  </div>
      <div class="generatep-main">
        <div class="generatep-box">
          <div class="loadingio-spinner">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="generatep-box">
          <div class="loadingio-spinner">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="generatep-box">
          <div class="loadingio-spinner">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="generatep-box">
          <div class="loadingio-spinner">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>

      </div>
      <div class="btn-wrapper">
        <button type="button" class="btn btn-dark">Generate<img src="assets/icons/icon-generate.svg" alt=""></button>
    </div>
  
  </div>

  <div class="generate-promt-modal">
    <div class="header">
      <h4>Generate portrait using prompt</h4>
      <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
    </div>
        <div class="generatep-main">
          <div class="generatep-box"><img src="assets/images/ai-img-1.png" alt=""></div>
          <div class="generatep-box"><img src="assets/images/ai-img-2.png" alt=""></div>
          <div class="generatep-box"><img src="assets/images/ai-img-3.png" alt=""></div>
          <div class="generatep-box"><img src="assets/images/ai-img-4.png" alt=""></div>
  
        </div>
        <div class="btn-wrapper">
          <button type="button" class="btn btn-dark">ReGenerate<img src="assets/icons/icon-generate.svg" alt=""></button>
      </div>
    
    </div> 
    
<div class="generate-promt-modal">
  <div class="header">
    <h4>Generate portrait using prompt</h4>
    <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
  </div>
      <div class="generatep-main">
        <div class="generatep-big-box"><img src="assets/images/ai-img-big-2.png" alt=""></div>
      </div>
      <div class="btn-wrapper">
        <button type="button" class="btn btn-green">Insert</button>
        <button type="button" class="btn btn-dark">ReGenerate<img src="assets/icons/icon-generate.svg" alt=""></button>
    </div>
  
  </div>
  

       <div class="available-modal">
        <div class="header">
          <h4>Available MAPS</h4>
          <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
        </div>
        
        
              <div class="available-body">
             
                WorldTumbler - Elmsywk
              </div>
            
            <div class="btn-wrapper">
              <button type="button" class="btn btn-green">Accept</button>
          </div>
        
        </div>  

         <div class="wcmap-modal">
          <div class="header">
            <h4>Welcome to MAPNAME</h4>
          </div>
          <div class="wcmap-body">
            Place the game token where this party will begin their adventure><br>
            click the Accept button (lower right) when ready to proceed.
          </div>
        </div> 

 
        <div class="confirm-container">
          <div class="header">
            <h4>PLEASE CONFIRM</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><img src="assets/icons/icon-close.svg" alt=""></button>
            </div>
            <div class="confirm-content">
              <p>By clicking Confirm, the Character selected will be removed from the party.</p>
              <p>Pins placed by the character will remain in the characters timeline.</p>
              <p>All pins placed by the Game Master will transition into storylines within the individual character's journey timeline. This allows for continuity in character storyline while opening new opportunities for solo or group campaigns.</p>
              <p>Proceed only if you're ready to part ways.</p>
          </div>
          <div class="btn-sec">
            <button class="btn btn-theme">Cancel</button>
            <button class="btn btn-green">Remove</button>
          </div>
        
        
        </div>

        <div class="confirm-container">
          <div class="header">
            <h4>PLEASE READ AND CONFIRM</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><img src="assets/icons/icon-close.svg" alt=""></button>
            </div>
            <div class="confirm-content">
              <p>By clicking Confirm, this Party will be disbanded, marking the end of your shared journey.</p>
              <p>All pins placed by the Game Master will transition into storylines within the individual character's journey timeline. This allows for continuity in character storyline while opening new opportunities for solo or group campaigns. </p>
              <p>Proceed only if you’re ready to part ways and forge ahead on separate paths.</p>
          </div>
          <div class="btn-sec">
            <button class="btn btn-theme">Cancel</button>
            <button class="btn btn-green">Remove</button>
          </div>
        
        
        </div> 


        <div class="its-subscibe-modal">
          <div class="header">
            <h4>It looks like...</h4>
            <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
          </div>
          
          
                <div class="its-subscribe-body">
                  <p>Your current subscription Tier does not allow for map creation or you've already uploaded to your limit.</p>
                  <p>Please increase your subscription tier to add additional maps.</p>
                </div>
              
              <div class="btn-wrapper">
                <button type="button" class="btn btn-dark">Subscribe</button>
            </div>
          
          </div> 


          <div class="confirm-del-container">
            <div class="header">
              <h4>PLEASE READ AND CONFIRM</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><img src="assets/icons/icon-close.svg" alt=""></button>
              </div>
              <div class="confirm-del-content">
                <p>By clicking Confirm, this MAP will be permanently DELETED. </p>
                <p>All Characters will be placed back into Player portfolios and made available for other games. </p>
                <p>All Content created will remain in the Players store and will be searchable for use in other maps and can still be placed in newly loaded maps.</p>
                  <p>Pins placed by Game Master or Player will transition to the individual character's journey timeline allowing for continuity of character story. </p>
                <p>If you are looking to update Layer data (Religion, Culture, etc please see the modify option labeled update map)</p>
            </div>
            <div class="cred-text">
              <p>CONFIRM ONLY IF YOU ARE ABSOLUTELY SURE!</p>
            <p>This action cannot be undone!</p>
            </div>
            <div class="btn-sec">
              <button class="btn btn-theme">Cancel</button>
              <button class="btn btn-green">Confirm</button>
            </div>
          
          
          </div> 

          <div class="ecity-modal">
            <div class="header">
              <h4>PLEASE CONFIRM</h4>
              <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
            </div>
                  <div class="ecity-body">
                    Enter the city?
                  </div>
                <div class="btn-wrapper">
                  <button type="button" class="btn btn-theme">Cancel</button>
                  <button type="button" class="btn btn-green">Yes</button>
              </div>
            </div>  

            <div class="savef-modal">
              <div class="header">
                <h4>Save to Favourites</h4>
                <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
              </div>
                    <div class="savef-body">
                      <a href="#">Create New Content</a>
                      <a href="#">Add to Journal</a>
                      <a href="#">GM TOOLS</a>
                    </div>
              </div> 

              <div class="favorites-modal">
                <div class="header">
                  <h4>Favourites</h4>
                  <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
                </div>
                      <div class="favorites-body">
                        <div class="form-check-box">
                          <div class="form-check-b">
                            <input type="checkbox" value="" id="cb6">
                            <label>Location 1</label>
                          </div>
                          <span><img src="assets/icons/icon-close.svg" alt=""></span>
                        </div>
                        <div class="form-check-box">
                          <div class="form-check-b">
                            <input type="checkbox" value="" id="cb6">
                            <label>Location 2</label>
                          </div>
                          <span><img src="assets/icons/icon-close.svg" alt=""></span>
                        </div>
                        <div class="form-check-box">
                          <div class="form-check-b">
                            <input type="checkbox" value="" id="cb6">
                            <label>Location 3</label>
                          </div>
                          <span><img src="assets/icons/icon-close.svg" alt=""></span>
                        </div>
                        <div class="form-check-box">
                          <div class="form-check-b">
                            <input type="checkbox" value="" id="cb6">
                            <label>Location 4</label>
                          </div>
                          <span><img src="assets/icons/icon-close.svg" alt=""></span>
                        </div>
                        <div class="form-check-box">
                          <div class="form-check-b">
                            <input type="checkbox" value="" id="cb6">
                            <label>Location 5</label>
                          </div>
                          <span><img src="assets/icons/icon-close.svg" alt=""></span>
                        </div>
                      </div>
                </div> 

                <div class="favorites-modal">
                  <div class="header">
                    <h4>Journal</h4>
                    <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
                  </div>
                        <div class="favorites-body">
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>New Journal Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>Latest Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                          <div class="form-check-box">
                            <div class="form-check-b">
                              <input type="checkbox" value="" id="cb6">
                              <label>Oldest Entry</label>
                            </div>
                            <span><img src="assets/icons/icon-edit-white.svg" alt=""></span>
                          </div>
                        </div>
                  </div> 

                  <div class="gmtool-modal">
                    <div class="header">
                      <h4>Game Master Tools</h4>
                      <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
                    </div>
                          <div class="gmtool-body">
                            <p>Expose Map Area</p>
                            <p>Expose Map Area and drop Pin</p>
                            <p>Teleport Party Token</p>
                            <p>Expose Whole Map</p>
                            <p>Fog of War</p>
                          </div>
                    </div> 

                    <div class="gmmappin-modal">
                      <button class="close-button"><img src="assets/icons/icon-close.svg" alt=""></button>
                            <div class="gmmappin-body">
                              <div class="gm-img">
                                <img src="assets/images/game1.png" alt="">
                              </div>
                              <ul>
                                <li class="title"><span>Title:</span> <span>Fury of the fire elemental</span></li>
                                <li><span>Type:</span> <span>One Shot</span></li>
                                <li><span>Recommended Players:</span> <span>4</span></li>
                                <li><span>Recommended Party Level:</span> <span>16</span></li>
                                <li><span>Description:</span> <span>A once peaceful village, Ashwood, has been set ablaze by a rampaging fire elemental mother. She scorches everything in sight, fueled by maternal rage.</span></li>
                                <li><span>Price:</span> <span>Free</span></li>
                                <li><span>Favourites:</span> <span>4.5 Reviews</span></li>
                              </ul>
                            </div>
                            <div class="btn-wrapper">
                              <button type="button" class="btn btn-green">Content page</button>
                              <button type="button" class="btn btn-green">Save?</button>
                          </div>
                      </div> 

                      <div class="gamejr-container">
                        <div class="header">
                          <h4>GAME JOURNAL</h4>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><img src="assets/icons/icon-close.svg" alt=""></button>
                          </div>
                          <div class="gamejr-content">
                          <p>Capture the moment! Add a journal entry to record your adventure, including key events, discoveries, battles, NPC encounters, clues, reflections, or rumors.</p>
                        <p>You can reference characters, cities ,etc by using the #name.</p>
                        </div>
                        <form>
                          
                            <div class="add-gtop">
                            <label class="form-label">TITLE:</label>
                            <input type="text" class="form-control" />
                          </div>
                          <div class="add-gtop">
                            <label class="form-label">JOURNAL ENTRY:</label>
                            <textarea></textarea>
                            </div>
                            <div class="mapicon-sec">
                              <label class="form-label">MAP ICON:</label>
                              <div class="mi-box-wrap">
                              <div class="mi-box">
                                <img src="assets/images/map-icon1.png" alt="">
                              </div>
                              <div class="mi-box">
                                <img src="assets/images/map-icon2.png" alt="">
                              </div>
                              <div class="mi-box">
                                <img src="assets/images/map-icon3.png" alt="">
                              </div>
                              <div class="mi-box">
                                <img src="assets/images/map-icon4.png" alt="">
                              </div>
                              <div class="mi-box">
                                <img src="assets/images/map-icon5.png" alt="">
                              </div>
                              <div class="mi-box">
                                <img src="assets/images/map-icon1.png" alt="">
                              </div>
                            </div>
                              </div>
                      
                          <div class="btn-sec">
                            <button class="btn btn-green">Submit</button>
                          </div>
                        </form>
                      </div>


 
<div class="notification-bg">
  <div class="notification-heading">
    <h3>NOTIFICATIONS</h3>
  </div>
  <h4>PENDING GAME INVITATIONS</h4>
  <div class="notification-wrap">
    <div class="notification-card">
      <div class="notification-profile">

      </div>
      <div class="notification-content">
        <ul>
          <li><span>Game Name:</span> Sunday Players</li>
          <li><span>Game Master:</span> Peeky McGill</li>
          <li><span>Average Level:</span> 7</li>
        </ul>
        <ul>
          <li><span>Players Invited:</span> 6</li>
        </ul>
        <ul>
          <li><span>Invitation Date:</span> 10/26/2024</li>
          <li><span>Invite Expires:</span> Invite +14 days</li>
          <li><span>Party Level:</span> 42</li>
        </ul>

      </div>

      <div class="notification-btn">
        <button class="btn btn-green">Accept</button>
        <button class="btn btn-theme">Decline</button>
      </div>
    </div>
    <div class="notification-card">
      <div class="notification-profile">

      </div>
      <div class="notification-content">
        <ul>
          <li><span>Game Name:</span> Wednesday Funtimes</li>
          <li><span>Game Master:</span> Peeky McGill</li>
          <li><span>Average Level:</span> 4.5</li>
        </ul>
        <ul>
          <li><span>Players Invited:</span> 4</li>
        </ul>
        <ul>
          <li><span>Invitation Date:</span> 5/6/2024</li>
          <li><span>Invite Expires:</span> Invite +14 days</li>
          <li><span>Party Level:</span> 18</li>
        </ul>

      </div>

      <div class="notification-btn">
        <button class="btn btn-green">Accept</button>
        <button class="btn btn-theme">Decline</button>
      </div>
    </div>

  </div>
  <h4>System</h4>
  <button class="area-btn-sec">
    Area for System Messages
  </button>
</div>




<div class="ccselection-bg">
  <div class="ccselection-heading">
    <h3>Character Selection</h3>
    <button class="btn btn-theme">Decline</button>
  </div>
  <h4>PENDING GAME INVITATIONS</h4>
  <div class="ccselection-sec">
    <div class="ccselection-card">
        <div class="cp-card-game-profil">
          <div class="formbold-file-input">
          </div>
        </div>
        <div class="ccselection-content">
            <h5>Gert Spellusian</h5>
          <ul>
            <li><span>Level:</span> 11</li>
            <li><span>Race:</span> Human</li>
            <li><span>Class:</span> Magic User</li>
            <li><span>Alignment:</span> N</li>
            <li><span>Game:</span> Joe's D&D 5e</li>
            <li><span>Strength:</span> 09</li>
            <li><span>Intelligence:</span> 21</li>
            <li><span>Wisdom:</span> 14</li>
            <li><span>Dexterity:</span> 12</li>
            <li><span>Constitution:</span> 8</li>
            <li><span>Charisma:</span> 10</li>
          </ul>
        </div>
        <div class="ccselection-btn">
          <button class="btn btn-green">Select</button>
        </div>
    </div>
    <div class="ccselection-card">
      <div class="cp-card-game-profil">
        <div class="formbold-file-input">
        </div>
      </div>
      <div class="ccselection-content">
          <h5>Respen Lightfoot</h5>
        <ul>
          <li><span>Level:</span> 04</li>
          <li><span>Race:</span> Elf</li>
          <li><span>Class:</span> Druid</li>
          <li><span>Alignment:</span> NE</li>
          <li><span>Game:</span> Friday Night D&D</li>
          <li><span>Strength:</span> 13</li>
          <li><span>Intelligence:</span> 12</li>
          <li><span>Wisdom:</span> 14</li>
          <li><span>Dexterity:</span> 18</li>
          <li><span>Constitution:</span> 15</li>
          <li><span>Charisma:</span> 11</li>
        </ul>
      </div>
      <div class="ccselection-btn">
        <button class="btn btn-green">Select</button>
      </div>
  </div>
    <div class="btn-new-sec">
      <button class="btn btn-green">New</button>
    </div>
  </div>
</div> 


<div class="new-cc-modal">
  <div class="header">
    <h4>TIME to Create a new Character!</h4>
  </div>
        <div class="new-cc-body">
          Redirecting you to Character Creation step.
        </div>
      <div class="btn-wrapper">
        <button type="button" class="btn btn-theme">Back</button>
        <button type="button" class="btn btn-green">Proceed</button>
    </div>
  </div>  

  <div class="cc-slot-modal">
    <div class="header">
      <h4>Out of Character Slots!</h4>
    </div>
          <div class="cc-slot-body">
            <p>Your account has reached the active character limit.</p>
            <p>Please subscribe to gain more character slots or retire an existing character.</p>
          </div>
        <div class="btn-wrapper">
          <button type="button" class="btn btn-theme">Back</button>
          <button type="button" class="btn btn-green">Subscribe</button>
      </div>
    </div>  